var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen max-w-screen-xl m-auto"},[_c('div',{staticClass:"w-full px-2 md:px-6 text-gray-600 lg:py-6 lg:px-16 z-20"},[_c('div',{staticClass:"max-w-3xl m-auto"},[_c('login',{ref:"loginForm",on:{"register":function () {
            _vm.$router.push('/registro');
          },"forget":function($event){_vm.forgetMode = $event}}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }